var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube svg",
    clipPath: "url(#clip0_1491_14210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M22.19 3.04621C21.9325 2.07997 21.174 1.3191 20.2107 1.06087C18.4648 0.591566 11.4637 0.591566 11.4637 0.591566C11.4637 0.591566 4.46268 0.591566 2.71672 1.06087C1.75347 1.3191 0.994807 2.07997 0.737362 3.04621C0.269531 4.79745 0.269531 8.4513 0.269531 8.4513C0.269531 8.4513 0.269531 12.1051 0.737362 13.8565C0.994807 14.8226 1.75347 15.5835 2.71672 15.8418C4.46268 16.311 11.4637 16.311 11.4637 16.311C11.4637 16.311 18.4648 16.311 20.2107 15.8418C21.174 15.5835 21.9325 14.8226 22.19 13.8565C22.6579 12.1051 22.6579 8.4513 22.6579 8.4513C22.6579 8.4513 22.6579 4.79745 22.19 3.04621Z",
    fill: "#ED1D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M9.17383 11.7686L15.0253 8.4513L9.17383 5.13373V11.7686Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_14210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3883,
    height: 15.7195,
    fill: "white",
    transform: "translate(0.265625 0.59082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/youTube.01fd223eb26271164480ef10d7c45852.svg";
export { ForwardRef as ReactComponent };